<script setup>
import { useRouter } from 'vue-router';
import useAuth from '../../store/auth.store'

const router = useRouter()
const auth = useAuth()
const allowedMenus = auth.allowedMenus.value

const route = router.resolve(router.currentRoute.value.query.path)

const isAllowed = route.matched.every(v => !v.meta.menu || allowedMenus.includes(v.meta.menu))

console.log("forbidden");
if (isAllowed) {
  router.push(route.fullPath)
}

const label = route.matched.map(v => v.meta.label).filter(Boolean).pop()

</script>

<template lang="pug">
.forbidden
  q-banner
    template(#avatar)
      q-icon(name="warning" color="negative")
    .text-h6 Танд энэ агуулгыг үзэх зөвшөөрөл байхгүй байна: "{{ label }}"
    template(#action)
      q-btn(flat color="white" label="Буцах" :to="{ name: 'main' }")
      q-btn(flat color="white" label="Тохиргоо" :to="{ name: 'settings' }")
</template>